import React from 'react';
import moment from 'moment';
import logo from '../../assets/TenAgents-logo.png'
import generateInvoice from '../../containers/Desk/claim/claimProcessing/generateInvoice';
import { MEDIA_URL } from '../../request';

class ReceiptPDF extends React.Component {
    render() {
        let companyDetail = JSON.parse(localStorage.getItem('company-details'))
        let companyLogo = companyDetail.companyLogo && Array.isArray(companyDetail.companyLogo) ? `${MEDIA_URL}${companyDetail.companyLogo[0].url}` : companyDetail.companyLogo ? companyDetail.companyLogo : logo;
        const { generatedReceipt } = this.props;
        return (
            <div>
                <div className="receipt-body">
                    <header className="clearfix receipt-header">
                        <div id="receipt-header-logo">
                            <img src={`${companyLogo ? companyLogo : logo}`} alt='tp-logo' />
                        </div>
                        <h1 className="receipt-title">Receipt</h1>
                        <div id="receipt-header-company" className="clearfix">
                            <div>{companyDetail.companyName}</div>
                            <div>{companyDetail.companyAddress}</div>
                            <div>{companyDetail.companyPhone}</div>
                            <div>{companyDetail.companyEmail}</div>
                            <div>{companyDetail.companyGst}</div>
                        </div>
                        <div id="receipt-header-student">
                            <div><span>Receipt No.</span> {generatedReceipt.receiptNumber ? generatedReceipt.receiptNumber : 'NA'} </div>
                            <div><span>Receipt Date</span> {generatedReceipt.createdDate ? moment(generatedReceipt.createdDate).format('lll') : 'NA'} </div>
                        </div>
                    </header>
                    <main>
                        <table className="receipt-header-details">
                            <thead>
                                <tr>
                                    <th className="service">Mode</th>
                                    <th className="service">SERVICE</th>
                                    <th className="desc">Client's Name</th>
                                    <th>DOB</th>
                                    <th className="desc">Passport No.</th>
                                    <th className="desc">Client's Mobile</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="service">{generatedReceipt.paymentType}</td>
                                    <td className="service">{generatedReceipt.amountType}</td>
                                    <td className="desc">{generatedReceipt.studentName}</td>
                                    <td style={{ textAlign: 'center' }}>{generatedReceipt.dob}</td>
                                    <td className="service">{generatedReceipt.passportNo}</td>
                                    <td className="desc">{generatedReceipt.studentMobile}</td>
                                    <td className="qty">{generatedReceipt.totalAmount ? generatedReceipt.totalAmount.toFixed(2) : '0.00'}</td>
                                </tr>
                                <tr>
                                    <td colSpan="6">SUBTOTAL</td>
                                    <td className="total">{generatedReceipt.amount ? generatedReceipt.amount.toFixed(2) : '0.00'}</td>
                                </tr>
                                <tr>
                                    <td colSpan="6">CGST</td>
                                    <td className="total">{generatedReceipt.cgstRate ? generatedReceipt.cgstRate.toFixed(2) : '0.00'}</td>
                                </tr>
                                <tr>
                                    <td colSpan="6">SGST</td>
                                    <td className="total">{generatedReceipt.sgstRate ? generatedReceipt.sgstRate.toFixed(2) : '0.00'}</td>
                                </tr>
                                <tr>
                                    <td colSpan="6" className="grand total">GRAND TOTAL</td>
                                    <td className="grand total">{generatedReceipt.totalAmount ? generatedReceipt.totalAmount.toFixed(2) : '0.00'}</td>
                                </tr>
                            </tbody>
                        </table>
                        {/* Terms & Conditions Section */}
                        <div className="receipt-terms">
                            <h3>Terms & Conditions:</h3>
                            <ul>
                                <li>Fees paid are non-refundable under any circumstances.</li>
                                <li>Fees are non-transferable to any other student or service.</li>
                                <li>The receipt issued is valid only for the services mentioned.</li>
                                <li>Clients are advised to retain this receipt for future reference.</li>
                            </ul>
                        </div>
                    </main>
                    <footer className="receipt-footer">
                        Receipt was created on a computer and is valid without the signature and seal.
                    </footer>
                </div>
            </div>
        )
    }
};
export default ReceiptPDF;